import { useMediaQuery } from '@medly-components/utils';
import { useTheme } from 'styled-components';

export const useIsTab = () => {
    const theme = useTheme();
    return useMediaQuery(`@media (max-width: ${theme.breakpoints.M.min}px)`);
};
